<template>
  <basic-container>
    <avue-crud
            :option="option"
            :data="data"
            :page.sync="page"
            :search.sync="search"
            ref="crud"
            @row-del="rowDel"
            v-model="form"
            :permission="permissionList"
            @row-update="rowUpdate"
            @row-save="rowSave"
            :before-open="beforeOpen"
            @search-change="searchChange"
            @search-reset="searchReset"
            @refresh-change="refreshChange"
            @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad">
    </avue-crud>
  </basic-container>
</template>

<script>
import mixin from '@/util/mixin'

export default {
  mixins: [mixin],
  data () {
    return {
      module: 'user/recorderror',
      form: {},
      search: {
        pt: '2'
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        menu: false,
        viewBtn: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        selection: true,
        indexLabel: '序号',
        columnBtn: false,
        column: [
          {
            label: '核销人员',
            prop: 'userId',
            type: 'select',
            dicUrl: '/user/rpauser/dict/common',
            props: {
              value: 'id',
              label: 'xm'
            }
          },
          {
            label: '日志类型',
            prop: 'type',
            rules: [{
              required: true,
              message: '请输入日志类型'
            }]
          },
          {
            label: '异常内容',
            prop: 'info',
            rules: [{
              required: true,
              message: '请输入异常内容'
            }]
          },
          {
            label: '异常科目代码',
            prop: 'errorTable',
            rules: [{
              required: true,
              message: '请输入异常申报表'
            }]
          },
          {
            label: '区域',
            prop: 'area',
            type: 'select',
            dicUrl: '/sys/dict/code/area',
            rules: [{
              required: true,
              message: '请选择区域'
            }]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            rules: [{
              required: true,
              message: '请输入创建时间'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    permissionList () {
      return {
        addBtn: this.permission.user_recorderror_add,
        viewBtn: this.permission.user_recorderror_view,
        delBtn: this.permission.user_recorderror_delete,
        editBtn: this.permission.user_recorderror_edit
      }
    }
  },
  methods: {
  }
}
</script>
